import type { ReactNode } from "react";

export interface ProductDetailSectionProps {
  children: ReactNode;
}

/**
 * El envoltorio de la ficha: el aire de abajo, y nada más.
 *
 * ── Ya no pone el ancho ──────────────────────────────────────────────
 * Lo pone `ProductDetailContainer`, y lo pone POR DENTRO. Aquí el
 * contenido va suelto a propósito: el estandarte tiene que llegar a los
 * dos bordes de la ventana, y un contenedor con margen alrededor de todo
 * lo hacía imposible — era exactamente lo que lo convertía en una
 * tarjeta metida en la página en vez de una portada a sangre.
 *
 * ── Y ya no lleva "Volver al catálogo" (Anahí, 26-ago) ───────────────
 * La barra era un rectángulo crema a lo ancho entre la barra superior y
 * el estandarte, y partía la página en dos justo antes de lo que más
 * importa. La quitamos ENTERA en vez de moverla, y no por sitio: es que
 * la vuelta al catálogo ya estaba resuelta TRES veces en la misma
 * pantalla.
 *
 *   · el logotipo de la barra superior apunta a `/shop` (`BrandLogo`)
 *   · el panel de MENÚ lleva "Tienda → /shop" (`SiteMenuPanel`)
 *   · el pie lleva "Catálogo → /shop" (`SiteFooter`)
 *
 * Con tres caminos, el cuarto no es una salida más: es ruido que enseña
 * a no fijarse en ninguno. Y las tres siguen ahí cuando la petición
 * falla, que era el único argumento que sostenía la barra —quien llega
 * por un enlace compartido no tiene un "atrás"—: la barra superior se
 * pinta pase lo que pase con el producto, y el 404 trae además su propio
 * botón "Ver el catálogo".
 *
 * De paso, el estandarte queda pegado a la barra superior, que es
 * exactamente donde está en la ficha original.
 *
 * ── Entonces, ¿por qué sigue existiendo esta pieza? ──────────────────
 * Porque el aire de abajo es de la PANTALLA, no de la ficha: lo
 * necesitan igual el esqueleto, el 404 y el aviso de error, y sin este
 * envoltorio cada uno de los cuatro estados llevaría pegada su propia
 * clase de maquetación — cuatro copias que se separan a la primera.
 */
export function ProductDetailSection({ children }: ProductDetailSectionProps) {
  return <section className="pb-20 sm:pb-28">{children}</section>;
}
